export type SecondFactorRequiredAction = {
	type: 'SECOND_FACTOR_REQUIRED';
};

export default (): SecondFactorRequiredAction => ({
	type: 'SECOND_FACTOR_REQUIRED',
});
